// copy pasta to install
// yarn add @fortawesome/fontawesome-svg-core @fortawesome/vue-fontawesome
// yarn add @fortawesome/free-brands-svg-icons @fortawesome/pro-light-svg-icons @fortawesome/pro-regular-svg-icons @fortawesome/pro-solid-svg-icons
// regex to find icons: 'fas'|'fab'|'far'|'fal'|'fad'

// DEV ONLY, USE TREESHAKING ON PROD
// import { fab } from '@fortawesome/free-brands-svg-icons'
// import { fal } from '@fortawesome/pro-light-svg-icons'
// import { far } from '@fortawesome/pro-regular-svg-icons'
// import { fas } from '@fortawesome/pro-solid-svg-icons'
// import { fad } from '@fortawesome/pro-duotone-svg-icons'

// export default [fab, far, fal, fas, fad]

import {
  faDiscord as fabDiscord,
  faSteamSymbol as fabSteamSymbol,
  faSteam as fabSteam,
  faTwitter as fabTwitter,
} from '@fortawesome/free-brands-svg-icons'

import {
  faBells as falBells,
  faCheckDouble as falCheckDouble,
} from '@fortawesome/pro-light-svg-icons'

import {
  faAt as farAt,
  faAngleDown as farAngleDown,
  faAngleLeft as farAngleLeft,
  faAngleRight as farAngleRight,
  faBell as farBell,
  faHashtag as farHashtag,
  faTimes as farTimes,
  faTimesCircle as farTimesCircle,
} from '@fortawesome/pro-regular-svg-icons'

import {
  faInfinity as fasInfinity,
  faBell as fasBell,
  faCheck as fasCheck,
  faInfoCircle as fasInfoCircle,
  faQuestionCircle as fasQuestionCircle,
  faCog as fasCog,
  faRepeat as fasRepeat,
  faChevronDoubleUp as fasChevronDoubleUp,
  faChevronDoubleDown as fasChevronDoubleDown,
  faVolumeSlash as fasVolumeSlash,
  faVolumeUp as fasVolumeUp,
  faSync as fasSync,
  faTimes as fasTimes,
  faSignInAlt as fasSignInAlt,
  faLanguage as fasLanguage,
  faExclamationTriangle as fasExclamationTriangle,
  faCaretDown as fasCaretDown,
  faAngleUp as fasAngleUp,
  faAngleDown as fasAngleDown,
  faUndo as fasUndo,
  faPlus as fasPlus,
  faBars as fasBars,
  faPlusCircle as fasPlusCircle,
  faMinus as fasMinus,
  faPencil as fasPencil,
  faLayerGroup as fasLayerGroup,
  faSquare as fasSquare,
  faEye as fasEye,
  faArrowLeft as fasArrowLeft,
  faCircle as fasCircle,
  faFilter as fasFilter,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faCommentsAlt as fadCommentsAlt,
  faExclamationTriangle as fadExclamationTriangle,
  faBan as fadBan,
  faSignOut as fadSignOut,
  faTools as fadTools,
  faCog as fadCog,
  faShieldCheck as fadShieldCheck,
  faFileContract as fadFileContract,
  faHistory as fadHistory,
  faBadgeCheck as fadBadgeCheck,
  faCoins as fadCoins,
  faBalanceScale as fadBalanceScale,
  faBoxFull as fadBoxFull,
  faUsersCrown as fadUsersCrown,
  faUserCircle as fadUserCircle,
  faCopy as fadCopy,
  faQrcode as fadQrcode,
  faGiftCard as fadGiftCard,
  faPlayCircle as fadPlayCircle,
  faSirenOn as fadSirenOn,
  faUserShield as fadUserShield,
  faInfoSquare as fadInfoSquare,
  faSync as fadSync,
  faExternalLinkAlt as fadExternalLinkAlt,
  faPencil as fadPencil,
  faAngry as fadAngry,
  faSword as fadSword,
  faSwords as fadSwords,
  faRobot as fadRobot,
  faLongArrowRight as fadLongArrowRight,
  faLongArrowLeft as fadLongArrowLeft,
  faPencilAlt as fadPencilAlt,
  faTrash as fadTrash,
  faCalendarAlt as fadCalendarAlt,
  faClock as fadClock,
  faList as fadList,
  faExternalLinkSquareAlt as fadExternalLinkSquareAlt,
  faCommentSlash as fadCommentSlash,
  faCrown as fadCrown,
  faSparkles as fadSparkles,
  faExternalLink as fadExternalLink,
  faCheckSquare as fadCheckSquare,
  faUsers as fadUsers,
  faPaintBrush as fadPaintBrush,
  faInfoCircle as fadInfoCircle,
  faLock as fadLock,
  faSquareFull as fadSquareFull,
  faSortNumericDown as fadSortNumericDown,
  faSortNumericUp as fadSortNumericUp,
  faBadgePercent as fadBadgePercent,
  faPercentage as fadPercentage,
  faMouse as fadMouse,
  faKeyboard as fadKeyboard,
  faGamepadAlt as fadGamepadAlt,
  faUniversity as fadUniversity,
  faPollPeople as fadPollPeople,
  faBackpack as fadBackpack,
  faClone as fadClone,
  faBolt as fadBolt,
  faCheckDouble as fadCheckDouble,
  faArrowAltSquareUp as fadArrowAltSquareUp,
  faHandHoldingHeart as fadHandHoldingHeart,
  faExchange as fadExchange,
  faGift as fadGift,
  faTree as fadTree,
  faSackDollar as fadSackDollar,
  faSkullCrossbones as fadSkullCrossbones,
  faShareAltSquare as fadShareAltSquare,
  faFireAlt as fadFireAlt,
} from '@fortawesome/pro-duotone-svg-icons'


export default [
  // brands
  fabTwitter,
  fabDiscord,
  fabSteam,
  fabSteamSymbol,

  // light
  falCheckDouble,
  falBells,

  // regular
  farBell,
  farTimes,
  farAt,
  farAngleDown,
  farAngleLeft,
  farAngleRight,
  farTimesCircle,
  farHashtag,

  // solid
  fasCog,
  fasRepeat,
  fasInfinity,
  fasUndo,
  fasQuestionCircle,
  fasChevronDoubleUp,
  fadClone,
  fasChevronDoubleDown,
  fasVolumeSlash,
  fasVolumeUp,
  fasCircle,
  fasBell,
  fasCheck,
  fasInfoCircle,
  fasTimes,
  fasSignInAlt,
  fasLanguage,
  fasExclamationTriangle,
  fasArrowLeft,
  fasCaretDown,
  fasSync,
  fasAngleUp,
  fasAngleDown,
  fasBars,
  fasPlus,
  fasFilter,
  fasMinus,
  fasPencil,
  fasLayerGroup,
  fasSquare,
  fasPlusCircle,

  // duotone
  fadCommentsAlt,
  fadExclamationTriangle,
  fadBan,
  fadBolt,
  fadSackDollar,
  fadSignOut,
  fadBadgeCheck,
  fadSkullCrossbones,
  fadBackpack,
  fadGamepadAlt,
  fadSortNumericDown,
  fadBadgePercent,
  fadSortNumericUp,
  fadUniversity,
  fadTools,
  fadCheckDouble,
  fadMouse,
  fadKeyboard,
  fadCog,
  fadPollPeople,
  fadShieldCheck,
  fasEye,
  fadFileContract,
  fadCoins,
  fadBoxFull,
  fadUsersCrown,
  fadCopy,
  fadQrcode,
  fadGiftCard,
  fadSirenOn,
  fadUserShield,
  fadInfoSquare,
  fadSync,
  fadBalanceScale,
  fadHistory,
  fadExternalLinkAlt,
  fadGift,
  fadTree,
  fadPencil,
  fadFireAlt,
  fadExchange,
  fadPlayCircle,
  fadShareAltSquare,
  fadAngry,
  fadRobot,
  fadUserCircle,
  fadLongArrowRight,
  fadLongArrowLeft,
  fadPencilAlt,
  fadTrash,
  fadCalendarAlt,
  fadClock,
  fadSword,
  fadSwords,
  fadList,
  fadExternalLinkSquareAlt,
  fadPercentage,
  fadCommentSlash,
  fadCrown,
  fadExternalLink,
  fadSparkles,
  fadArrowAltSquareUp,
  fadCheckSquare,
  fadUsers,
  fadPaintBrush,
  fadInfoCircle,
  fadLock,
  fadSquareFull,
  fadHandHoldingHeart,
]
